/** Extract the Cognito `sub` (stable user id) from a JWT access token. */
export function subFromToken(token) {
  try {
    const b64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(b64)).sub;
  } catch {
    return undefined;
  }
}
